<h3 class="with-manual-link">
  <span i18n="@@statistics">Statistik</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Insights/Statistik"></app-manual-link>
</h3>
<div
  class="my-3"
  [@.disabled]="true"
>
  @if (!this.isThisBotUnused) {
  <div>
    <app-statistics-month-selector
      [minMonth]="this.firstMonth"
      [maxMonth]="this.lastMonth"
      [(value)]="this.selectedMonth"
      (valueChange)="this.computeFilteredUsage()"
    ></app-statistics-month-selector>
  </div>
  }
  @if (this.isThisBotUnused) {
  <p-message
    severity="secondary"
    [closable]="false"
  >
    <span i18n="@@unused-bot-no-tokens">Noch keine Token-Nutzung vorhanden.</span>
  </p-message>
  }
</div>

@if (this.filteredUsageStats !== undefined) {
<div>
  @if (this.filteredUsageStats.all.length === 0) {
  <p-message
    severity="secondary"
    [closable]="false"
  >
    <span i18n="@@statistics-no-data-for-month">Für diesen Monat sind noch keine Statistiken vorhanden.</span>
  </p-message>
  }
  @if (this.filteredUsageStats.GPT4O.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4o'"
      [usageStats]="this.filteredUsageStats.GPT4O"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT4OMINI.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4o-mini'"
      [usageStats]="this.filteredUsageStats.GPT4OMINI"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT41.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4.1'"
      [usageStats]="this.filteredUsageStats.GPT41"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT41MINI.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4.1-mini'"
      [usageStats]="this.filteredUsageStats.GPT41MINI"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT41NANO.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4.1-nano'"
      [usageStats]="this.filteredUsageStats.GPT41NANO"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT5.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5'"
      [usageStats]="this.filteredUsageStats.GPT5"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT5MINI.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5-mini'"
      [usageStats]="this.filteredUsageStats.GPT5MINI"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT5NANO.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5-nano'"
      [usageStats]="this.filteredUsageStats.GPT5NANO"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT51.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.1'"
      [usageStats]="this.filteredUsageStats.GPT51"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT52.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.2'"
      [usageStats]="this.filteredUsageStats.GPT52"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT54.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.4'"
      [usageStats]="this.filteredUsageStats.GPT54"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT54MINI.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.4-mini'"
      [usageStats]="this.filteredUsageStats.GPT54MINI"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT54NANO.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.4-nano'"
      [usageStats]="this.filteredUsageStats.GPT54NANO"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT55.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.5'"
      [usageStats]="this.filteredUsageStats.GPT55"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT55PRO.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.5-pro'"
      [usageStats]="this.filteredUsageStats.GPT55PRO"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT56.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.6'"
      [usageStats]="this.filteredUsageStats.GPT56"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT56SOL.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.6-sol'"
      [usageStats]="this.filteredUsageStats.GPT56SOL"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT56TERRA.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.6-terra'"
      [usageStats]="this.filteredUsageStats.GPT56TERRA"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT56LUNA.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-5.6-luna'"
      [usageStats]="this.filteredUsageStats.GPT56LUNA"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPT6ASTRA.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-6-astra'"
      [usageStats]="this.filteredUsageStats.GPT6ASTRA"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.DEEPSEEKR18B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'deepseek-r1:8b'"
      [usageStats]="this.filteredUsageStats.DEEPSEEKR18B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.DEEPSEEKR114B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'deepseek-r1:14b'"
      [usageStats]="this.filteredUsageStats.DEEPSEEKR114B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GEMMA34B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gemma3:4b'"
      [usageStats]="this.filteredUsageStats.GEMMA34B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.LLAMA323B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'llama3.2:3b'"
      [usageStats]="this.filteredUsageStats.LLAMA323B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.MISTRAL7B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'mistral:7b'"
      [usageStats]="this.filteredUsageStats.MISTRAL7B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.QWEN25VL7B.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'qwen2.5vl:7b'"
      [usageStats]="this.filteredUsageStats.QWEN25VL7B"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.TTS.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'tts-1'"
      [usageStats]="this.filteredUsageStats.TTS"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.GPTTTS.length > 0) {
  <p-card styleClass="mb-3 shadow-sm">
    <app-usage-statistic-chart
      [model]="'gpt-4o-mini-tts'"
      [usageStats]="this.filteredUsageStats.GPTTTS"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
  @if (this.filteredUsageStats.HEYGEN.length > 0) {
  <p-card styleClass="shadow-sm">
    <app-usage-statistic-chart
      [model]="'heygen_streaming_avatar'"
      [usageStats]="this.filteredUsageStats.HEYGEN"
      [selectedMonth]="this.selectedMonth"
    ></app-usage-statistic-chart>
  </p-card>
  }
</div>
}